module.exports = __webpack_public_path__ + "img/studio.e96f3340.svg";